"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPoolOrPairtoRPool = exports.convertTokenToBento = exports.getBentoChainId = void 0;
const bignumber_1 = require("@ethersproject/bignumber");
const tines_1 = require("@sushiswap/tines");
const ConstantProductPool_1 = require("../ConstantProductPool");
const Fee_1 = require("../Fee");
const Pair_1 = require("../Pair");
const StablePool_1 = require("../StablePool");
function getBentoChainId(chainId) {
    return `Bento ${chainId}`;
}
exports.getBentoChainId = getBentoChainId;
function convertTokenToBento(token) {
    const t = { ...token };
    t.chainId = getBentoChainId(token.chainId);
    t.name = getBentoChainId(token.name);
    t.symbol = getBentoChainId(token.symbol);
    delete t.tokenId;
    return t;
}
exports.convertTokenToBento = convertTokenToBento;
function convertPoolOrPairtoRPool(pool, convertTokensToBento = false) {
    if (pool instanceof Pair_1.Pair) {
        return new tines_1.ConstantProductRPool(pool.liquidityToken.address, pool.token0, pool.token1, Fee_1.Fee.DEFAULT / 10000, bignumber_1.BigNumber.from(pool.reserve0.quotient.toString()), bignumber_1.BigNumber.from(pool.reserve1.quotient.toString()));
    }
    else if (pool instanceof ConstantProductPool_1.ConstantProductPool) {
        return new tines_1.ConstantProductRPool(pool.liquidityToken.address, convertTokensToBento ? convertTokenToBento(pool.token0.wrapped) : pool.assets[0].wrapped, convertTokensToBento ? convertTokenToBento(pool.token1.wrapped) : pool.assets[1].wrapped, 
        // pool.assets[0].wrapped as RToken,
        // pool.assets[1].wrapped as RToken,
        pool.fee / 10000, bignumber_1.BigNumber.from(pool.reserves[0].quotient.toString()), bignumber_1.BigNumber.from(pool.reserves[1].quotient.toString()));
    }
    else if (pool instanceof StablePool_1.StablePool) {
        return new tines_1.StableSwapRPool(pool.liquidityToken.address, 
        // pool.token0 as RToken,
        // pool.token1 as RToken,
        convertTokensToBento ? convertTokenToBento(pool.token0.wrapped) : pool.token0, convertTokensToBento ? convertTokenToBento(pool.token1.wrapped) : pool.token1, pool.fee / 10000, bignumber_1.BigNumber.from(pool.reserve0
            .toShare({
            elastic: pool.total0.elastic,
            base: pool.total0.base,
        })
            .quotient.toString()), bignumber_1.BigNumber.from(pool.reserve1
            .toShare({
            elastic: pool.total1.elastic,
            base: pool.total1.base,
        })
            .quotient.toString()), 
        // BigNumber.from(pool.reserve0.quotient.toString()),
        // BigNumber.from(pool.reserve1.quotient.toString()),
        pool.token0.decimals, pool.token1.decimals, {
            elastic: bignumber_1.BigNumber.from(pool.total0.elastic.toString()),
            base: bignumber_1.BigNumber.from(pool.total0.base.toString()),
        }, {
            elastic: bignumber_1.BigNumber.from(pool.total1.elastic.toString()),
            base: bignumber_1.BigNumber.from(pool.total1.base.toString()),
        });
    }
    else {
        throw new Error('Unknown pool type');
    }
}
exports.convertPoolOrPairtoRPool = convertPoolOrPairtoRPool;
//# sourceMappingURL=convertPoolOrPairtoRPool.js.map